import React from 'react'

export default function Introduction(){
   return (
    <div>
        <i>Welcome to my personal page.</i>

        <div style={{paddingTop:30,textAlign:"justify"}}>
            I am a final year <strong>Computer Engineering(CPEG)</strong> student at the Hong Kong University of Science and Technology. 
            I am a tech enthusiast, a persistent problem-solver and occasionally a wannabe influencer. 
            My major interest lies in <strong>software engineering (web/mobile application) and machine learning</strong>, and, am proficient and have experience in <strong>robotics engineering</strong>.
        </div>
    </div>
   );
}